import { useState } from 'react';
import { logout, post } from '../lib/api';
import { toast } from './toasts';
import { Button, ErrorText, Field, Input, Modal } from './ui';

/** O próprio usuário troca a senha. As sessões são encerradas: entra de novo com a nova. */
export function ChangePasswordModal({ onClose }: { onClose: () => void }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (next !== confirm) return setError(new Error('A confirmação não confere com a nova senha'));
    if (next.length < 10) return setError(new Error('A nova senha precisa de pelo menos 10 caracteres'));
    setSaving(true);
    setError(null);
    try {
      await post('/users/me/password', { currentPassword: current, newPassword: next });
      toast('Senha trocada. Entre de novo com a nova senha.', 'ok');
      await logout();
    } catch (err) {
      setError(err);
      setSaving(false);
    }
  };

  return (
    <Modal
      open
      title="Trocar minha senha"
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Cancelar</Button>
          <Button variant="primary" loading={saving} onClick={() => void save()} disabled={!current || !next || !confirm}>
            Trocar senha
          </Button>
        </>
      }
    >
      <Field label="Senha atual">
        <Input type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus />
      </Field>
      <Field label="Nova senha" hint="(mínimo de 10 caracteres)">
        <Input type="password" autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} />
      </Field>
      <Field label="Confirme a nova senha">
        <Input type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
      </Field>
      <p className="text-xs text-fg-soft">Depois de trocar, todas as suas sessões são encerradas e você entra de novo.</p>
      <ErrorText error={error} />
    </Modal>
  );
}
